/* eslint-disable import/first */
import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Divider,
  Grid,
  Badge,
} from '@material-ui/core';
import { useNavigate, useLocation } from '@reach/router';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useIntl } from 'react-intl';
const { selectDesktop } = Slices.appSlice;
const { getProfile } = Slices.profileSlice;
const { logout, loginGuest } = Slices.authSlice;
import { MdPhone } from '@react-icons/all-files/md/MdPhone';
const { clearAddress } = Slices.addressSlice;
const { clearState } = Slices.orderSlice;
import css from './index.module.scss';
import DrawerPwa from '../../components/DrawerPwa';
import DeleteAccount from './DeleteAccount';
import DeleteAccountError from './DeleteAccountError';

const MenuRouteCard = ({ navList }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();
  const isDesktop = useSelector(selectDesktop);
  const config = useSelector((state) => state.config);
  const contrySpecificValidation = config?.data?.data?.contrySpecificValidation;
  const profile = useSelector((state) => state.profile);
  const countryName = profile?.country;
  const [accountDeleteConfirmation, setAccountDeleteConfirmation] = useState(false);
  const [accountDeleteError, setAccountDeleteError] = useState(false);

  //const [path, setPath] = useState('');

  const isExist = contrySpecificValidation?.findIndex(({ country }) => country === countryName);
  // eslint:fix 'tel:' + ' ' is replaced by 'tel: '
  const path = 'tel: ' + contrySpecificValidation?.[isExist].customerCare;

  const handleNavigation = (url, name) => {
    if (name === 'logOut') {
      dispatch(logout()).then((resp) => {
        dispatch(clearAddress());
        dispatch(clearState());
        dispatch(loginGuest()).then((resp) => {
          dispatch(getProfile());
          window.history.go(-(window.history.length + 1));
          navigate(`/${intl.locale}/home`, { replace: true, state: { fromPage: 'logout' } });
        });

      });
    } else if (name === 'myFavorites') {
      navigate(`/${intl.locale}` + url, { replace: true });
    } else {
      navigate(`/${intl.locale}` + url, {
        replace: true,
        state: {
          oldLocation: location?.state?.oldLocation,
        },
      });
    }
  };

  return (
    <>
      <Box className={css.routeCardMargin}>
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={accountDeleteConfirmation}
          hideCloseButton={true}
          onClose={() => setAccountDeleteConfirmation(false)}
        >
          <DeleteAccount
            errorInDeleteAccount={() => setAccountDeleteError(true)}
            onClose={() => setAccountDeleteConfirmation(false)}
          />
        </DrawerPwa>
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={accountDeleteError}
          onClose={() => setAccountDeleteError(false)}
        >
          <DeleteAccountError onClose={() => setAccountDeleteError(false)} />
        </DrawerPwa>
        <Paper square>
          <List>
            {navList.map((itemList, idx) =>
              itemList.id === 'callSupport' ? (
                <>
                  <a href={path} className={css.listLinkItem} key={idx}>
                    <ListItem button key={`liMain_${itemList.id}`} className={css.supportLink}>
                      <Grid sx className={css.supportTextArea}>
                        <ListItemIcon className={css.iconImage}>
                          <itemList.icon size={20} color />
                        </ListItemIcon>
                        <ListItemText
                          className={css.staticLink}
                          primary={itemList.name}
                          key={`liText_${itemList.id}`}
                        >
                          {itemList.name}
                        </ListItemText>
                      </Grid>
                      <Grid>
                        <Badge badgeContent={intl.formatMessage({id: 'call'})} variant='contained' className={css.greenBadge} />
                      </Grid>

                      {/* </a> */}
                    </ListItem>
                  </a>
                </>
              ) : (
                <>
                  <ListItem
                    className={css.listLinkItem}
                    button
                    key={idx}
                    onClick={() => {
                      if (itemList.id === 'deleteAccount') {
                        if (isDesktop) {
                          handleNavigation(itemList.urlLink, itemList.id);
                        } else {
                          setAccountDeleteConfirmation(true);
                        }
                      } else {
                        handleNavigation(itemList.urlLink, itemList.id);
                      }
                    }}
                  >
                    <ListItemIcon className={css.iconImage} key={`liIcon_${itemList.id}`}>
                      {itemList.icon && <itemList.icon size={20} />}
                    </ListItemIcon>
                    <ListItemText
                      className={css.staticLink}
                      primary={itemList.name}
                      key={`liText_${itemList.id}`}
                    />
                  </ListItem>
                </>
              )
            )}
          </List>
        </Paper>
      </Box>
    </>
  );
};

export default MenuRouteCard;
